import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { useApi } from '../utils/api.js';
import { sharedStyles } from './shared/sharedStyles.js';

const CheckoutCallback = () => {
  const navigate = useNavigate();
  const { isSignedIn, isLoaded } = useUser();
  const { makeRequest } = useApi();

  useEffect(() => {
    const processCheckout = async () => {
      console.log('🎬 CheckoutCallback - isLoaded:', isLoaded, 'isSignedIn:', isSignedIn);

      // Wait for Clerk to load
      if (!isLoaded) {
        console.log('⏸️  Waiting for Clerk to load...');
        return;
      }

      // If not signed in, redirect to sign-in
      if (!isSignedIn) {
        console.log('❌ Not signed in, redirecting to sign-in...');
        navigate('/sign-in');
        return;
      }

      // Get pending checkout from localStorage
      const pendingCheckout = localStorage.getItem('pendingCheckout');
      console.log('🔍 Looking for pending checkout:', pendingCheckout);

      if (!pendingCheckout) {
        console.log('❌ No pending checkout found, redirecting to home...');
        navigate('/');
        return;
      }

      try {
        const { priceId, planName } = JSON.parse(pendingCheckout);
        console.log('🚀 Processing checkout - Plan:', planName, 'Price ID:', priceId);

        // Clear localStorage before making API call
        localStorage.removeItem('pendingCheckout');
        console.log('🗑️  Cleared pendingCheckout from localStorage');

        // Create checkout session
        console.log('📞 Creating checkout session...');
        const { url } = await makeRequest('billing/create-checkout-session', {
          method: 'POST',
          body: JSON.stringify({
            price_id: priceId,
            success_url: `${window.location.origin}/success`,
            cancel_url: `${window.location.origin}/#pricing`,
          }),
        });

        console.log('✅ Got checkout URL, redirecting to Stripe...');
        // Redirect to Stripe
        window.location.href = url;
      } catch (error) {
        console.error('❌ Checkout error:', error);
        alert(`Failed to start checkout: ${error.message}. Please try again.`);
        navigate('/#pricing');
      }
    };

    processCheckout();
  }, [isLoaded, isSignedIn, navigate, makeRequest]);

  // Show loading state
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: sharedStyles.colors.background,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        background: sharedStyles.colors.surface,
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        padding: '3rem 2rem',
        maxWidth: '400px',
        textAlign: 'center',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          margin: '0 auto 1.5rem',
          border: `4px solid ${sharedStyles.colors.primary}`,
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}></div>
        <h2 style={{
          fontSize: '1.5rem',
          fontWeight: '700',
          color: sharedStyles.colors.textPrimary,
          marginBottom: '0.5rem',
        }}>
          Setting up your subscription...
        </h2>
        <p style={{
          fontSize: '1rem',
          color: sharedStyles.colors.textSecondary,
        }}>
          Please wait while we redirect you to checkout.
        </p>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default CheckoutCallback;
